import logo_icbf from '../styles/images/logoICBF.svg';
import logo_sbfb from '../styles/images/logoFuturosBrillantes.svg';

export const Images = {
   logo_icbf,
   logo_sbfb
}